<div class="main-layout">
  <div class="nav-tabs">
    <ng-container *ngFor="let tab of tabs">
      <a [routerLink]="[tab.link]" routerLinkActive="active" class="tab" *ngIf="tab.access">{{tab.title | translate}}</a>
    </ng-container>
  </div>
  <div class="main-content">
    <router-outlet></router-outlet>
  </div>
</div>
